import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dashboard } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
// #TODO get data from services and remove demo data
import { statisticsDemo } from 'src/demo-data';

export function DashboardPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('dashboard-component.metatags.title'),
        description: t('dashboard-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myDashboard,
        index: false,
    });

    return <Dashboard statistics={statisticsDemo} />;
}
